import { Phone, Mail, MessageSquareText, MapPin } from "lucide-react";
import { CONTACT, IMAGES } from "@/data";

export default function Footer() {
  return (
    <footer className="bg-primary border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <img src={IMAGES.logoHorizontalWhite} alt="Cheeky Pups" className="h-12 w-auto mb-5" />
            <p className="text-white/70 max-w-sm font-medium">
              Trusted dog walking, boarding, sitting, daycare and house visits in
              South Brisbane. We’d love to meet your pup.
            </p>
            <div className="flex items-center gap-2 text-sm text-white/70 mt-5 font-semibold">
              <MapPin size={15} className="text-accent" /> {CONTACT.area}
            </div>
          </div>

          <div className="md:justify-self-end">
            <h4 className="font-display font-extrabold mb-5 text-white" style={{ fontSize: "2rem" }}>Get in touch</h4>
            <p className="text-sm text-white/70 mb-4 max-w-xs font-medium">
              We prefer a quick <span className="text-accent font-bold">SMS/WhatsApp message</span> over a call — text us and we’ll reply fast.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href={`sms:${CONTACT.sms}`}
                data-testid="footer-sms"
                className="inline-flex items-center gap-3 rounded-full bg-white px-5 py-3 text-sm font-bold text-primary hover:-translate-y-0.5 transition-transform w-fit"
              >
                <MessageSquareText size={16} /> SMS {CONTACT.phoneDisplay}
              </a>
              <a href={`tel:${CONTACT.phone}`} data-testid="footer-phone" className="inline-flex items-center gap-3 text-sm font-semibold text-white/80 hover:text-accent transition-colors">
                <Phone size={15} className="text-accent" /> {CONTACT.phoneDisplay}
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="inline-flex items-center gap-3 text-sm font-semibold text-white/80 hover:text-accent transition-colors">
                <Mail size={15} className="text-accent" /> {CONTACT.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/60 font-medium">
          <span>© {new Date().getFullYear()} Cheeky Pups. All rights reserved.</span>
          <span>Serving good dogs across South Brisbane.</span>
        </div>
      </div>
    </footer>
  );
}
